import React from "react";
import styles from "./NavTab.module.scss";

interface Props {
    tabs: Array<string>;
    activeTab: number;
    cb: Function;
    children: string | JSX.Element | JSX.Element[];
}

export default function NavTab({ tabs, activeTab, cb, children }: Props) {
    return (
        <>
            <div className={styles.navtab}>
                {tabs.map((el, idx) => (
                    <div
                        key={el}
                        onClick={() => cb(idx)}
                        className={activeTab === idx ? `${styles.tab} ${styles.active}` : `${styles.tab}`}
                    >
                        {el}
                    </div>
                ))}
            </div>
            <div className={styles.container}>
                <div className={styles.content}>{children}</div>
            </div>
        </>
    );
}
